import MaterialPaper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import React from 'react'

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '100%',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  layout: {
    flexDirection: 'column',
    margin: 'auto',
    '&.fullWidth': {
      width: '100%',
    },
    [theme.breakpoints.down(320)]: {
      width: '100%',
      padding: '0',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px',
    boxShadow: 'none',
    [theme.breakpoints.down(400)]: {
      padding: '20px',
      borderRadius: 0,
    },
  },
})

const Paper = React.forwardRef(
  (
    { backgroundColor, backgroundImage, children, classes, className, fullWidth, width, application, outsideContent },
    ref
  ) => {
    const backColor = {
      backgroundColor,
    }
    const backImage = {
      backgroundImage: `url(${backgroundImage})`,
    }
    const paperWidth = {
      width,
    }

    return (
      <div
        className={cn(classes.root, application)}
        style={(backgroundImage && backImage) || (backgroundColor && backColor) || null}
      >
        <main
          className={cn(classes.layout, className, {
            fullWidth,
          })}
          style={(!fullWidth && width && paperWidth) || null}
        >
          {outsideContent && outsideContent}
          <MaterialPaper className={classes.paper} ref={ref}>
            {children}
          </MaterialPaper>
        </main>
      </div>
    )
  }
)

Paper.displayName = 'Paper'

Paper.defaultProps = {
  backgroundColor: null,
  backgroundImage: null,
  classes: {},
  className: '',
  fullWidth: false,
  width: 450,
  application: '',
}

const PaperComponent = withStyles(styles)(Paper)
PaperComponent.displayName = 'Paper'
export default PaperComponent
